import { FaPhoneAlt } from "react-icons/fa";

function TopNav() {
  return (
    <div className="w-full sticky top-0 z-50 bg-gradient-to-r from-orange-700 to-orange-600 tems-center">
      <div className="max-w-7xl py-2 px-4 sm:px-6 lg:px-8 mx-auto flex  items-center justify-between text-white text-sm">
        <div className="font-semibold tracking-wide w-full text-center sm:text-left sm:w-auto">
          Building the Future with Technology
        </div>
        <div className="hidden sm:flex items-center gap-4 sm:w-auto justify-end">
          <a href="tel:+1234567890" className="flex items-center gap-2 hover:text-yellow-200 transition">
            <FaPhoneAlt className="inline-block" />
            <span>255714183424</span>
          </a>
          <span className="hidden sm:inline">|</span>
          <a href="mailto:info@altair.com" className="hover:text-yellow-200 transition">
            info@altair.co.tz
          </a>
        </div>
      </div>
    </div>
  )
}

export default TopNav